import { CLASS_SIGILS } from "@/lib/assets";

export const CLASSES = [
  {
    id: "sage",
    name: "Prompt Sage",
    title: "Weaver of Words",
    blurb: "Master of prompting and language. You bend LLMs to your will with the perfect phrasing.",
    sigil: CLASS_SIGILS.sage,
    tint: "text-violet-300",
    ring: "border-violet-400/40",
  },
  {
    id: "retriever",
    name: "The Retriever",
    title: "Seeker of Truths",
    blurb: "Ranger of RAG and retrieval. No knowledge stays hidden from your grasp.",
    sigil: CLASS_SIGILS.retriever,
    tint: "text-gem-light",
    ring: "border-gem/40",
  },
  {
    id: "architect",
    name: "The Architect",
    title: "Builder of Systems",
    blurb: "Artificer of production and system design. You raise AI systems that stand the test of scale.",
    sigil: CLASS_SIGILS.architect,
    tint: "text-sky-300",
    ring: "border-sky-400/40",
  },
  {
    id: "alchemist",
    name: "The Alchemist",
    title: "Transmuter of Models",
    blurb: "Master of fine-tuning and evaluation. You transmute raw models into gold.",
    sigil: CLASS_SIGILS.alchemist,
    tint: "text-emerald-300",
    ring: "border-emerald-400/40",
  },
];

export const getClass = (id) => CLASSES.find((c) => c.id === id) || null;

const RANKS = [
  { min: 1, title: "Novice" },
  { min: 3, title: "Apprentice" },
  { min: 5, title: "Adept" },
  { min: 8, title: "Mage" },
  { min: 11, title: "Magus" },
  { min: 15, title: "Archmage" },
];

export function rankTitle(level) {
  let t = "Novice";
  for (const r of RANKS) if (level >= r.min) t = r.title;
  return t;
}

// Cumulative XP curve: cost to reach level L from L-1 = 100 + (L-1)*50
export function levelFromXp(xp = 0) {
  let level = 1, need = 100, acc = 0;
  while (xp >= acc + need) {
    acc += need;
    level += 1;
    need = 100 + (level - 1) * 50;
  }
  const into = xp - acc;
  const pct = Math.max(0, Math.min(100, Math.round((into / need) * 100)));
  return { level, into, need, pct, rank: rankTitle(level) };
}

// --- AI Familiar: a terminal "daemon" you feed gold; evolves as it eats. -----
// Meal thresholds MUST match FAMILIAR_STAGE_MEALS in backend/server.py.
export const FAMILIAR_MEAL_COST = 15;

const FAMILIAR_STAGES = [
  { min: 0,  name: "Egg",    art: "  .----.\n ( o  o )\n  `----'" },
  { min: 3,  name: "Spark",  art: "  \\ ^_^ /\n   (   )\n    `-'" },
  { min: 8,  name: "Daemon", art: "  /\\_/\\\n ( o.o )\n  > ~ <" },
  { min: 16, name: "Oracle", art: " * /\\_/\\ *\n  ( @ @ )\n   > w <" },
];

export function familiarStage(meals = 0) {
  let idx = 0;
  for (let i = 0; i < FAMILIAR_STAGES.length; i++) if (meals >= FAMILIAR_STAGES[i].min) idx = i;
  const cur = FAMILIAR_STAGES[idx];
  const nxt = FAMILIAR_STAGES[idx + 1] || null;
  return { idx, name: cur.name, art: cur.art, isMax: !nxt, nextAt: nxt ? nxt.min : null, toNext: nxt ? nxt.min - meals : 0 };
}
